/*
 * @Description: 角色管理
 * @Date: 2024-11-16 13:13:03
 */
import { route } from './src/router';

const name = 'role-management';
export { name, route };
